// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import Login from './pages/Login';
import Chatbot from './pages/Chatbot';
import Physicians from './pages/Physicians';
import Appointments from './pages/Appointments';
import Register from './pages/Register'; // ✅ Already imported
import Logout from './pages/Logout'; // ✅ Add this line
import Footer from './components/layout/Footer';
import Navbar from './components/layout/Navbar';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} /> {/* ✅ Add this line */}
        <Route path="/chatbot" element={<Chatbot />} />
        <Route path="/physicians" element={<Physicians />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/logout" element={<Logout />} /> {/* ✅ Add this line */}
      </Routes>
    </Router>
  );
}

export default App;
